import { visitPath } from 'quick-quote/ui/actions'
import { useDispatch } from 'react-redux'
import { useMemo } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { analyticsPageViewEvent } from 'analytics/actions'
import { PATH, ROUTE_PATH } from '../../constants/path'
import { getToggles } from '../../feature-toggles'
import pageViewCapturer from '../../page-view-capturer'
import { PortalContainer } from '../../portal'
import { OptyList } from '../../opty'
import { MwpCustomerProfileList } from '../../my-wealth-plus'
import FNA from './fna/routes'
import OldQuickQuote from './old-quick-quote/routes'
import QuickQuote from './quick-quote/routes'
import { BrochureProductList } from '../../product-brochure'
import RequireAmlo from './require-amlo'

const guard = (Component) => (props) => (
  <RequireAmlo location={props.location}>
    <Component {...props} />
  </RequireAmlo>
)

const Routes = () => {
  const dispatch = useDispatch()

  const logPageView = useMemo(
    () =>
      pageViewCapturer({
        pageViewHandlers: [(event) => dispatch(analyticsPageViewEvent(event)), (path) => dispatch(visitPath(path))],
      }),
    [dispatch]
  )

  return (
    <Switch>
      <Route
        path={ROUTE_PATH.BROCHURE_LIST}
        component={guard((props) => (
          <BrochureProductList logPageView={logPageView} {...props} />
        ))}
      />
      {getToggles().ENABLE_FNA_FLOW && <Route path={ROUTE_PATH.PORTAL} component={PortalContainer} />}
      {getToggles().ENABLE_FNA_FLOW && (
        <Route
          path={PATH.FNA}
          component={guard((props) => (
            <FNA logPageView={logPageView} {...props} />
          ))}
        />
      )}
      {getToggles().ENABLE_FNA_FLOW && (
        <Route
          path={PATH.QUICK_QUOTE}
          component={guard((props) => (
            <QuickQuote logPageView={logPageView} {...props} />
          ))}
        />
      )}
      {getToggles().ENABLE_OPTY_MENU && (
        <Route
          path={ROUTE_PATH.OPTY}
          component={guard((props) => (
            <OptyList {...props} />
          ))}
        />
      )}
      {getToggles().ENABLE_MWP_MENU && (
        <Route
          path={ROUTE_PATH.MW_PLUS}
          component={guard((props) => (
            <MwpCustomerProfileList {...props} />
          ))}
        />
      )}
      {getToggles().ENABLE_FNA_FLOW && <Redirect from="/" to={ROUTE_PATH.PORTAL} />}
      <Route
        component={guard((props) => (
          <OldQuickQuote logPageView={logPageView} {...props} />
        ))}
      />
    </Switch>
  )
}

export default Routes
